import classNames from 'classnames'

import { formatDate } from 'ui-component-library/utils/helpers'
import style from './style.scss'

// /* Required for highlighting comments on direct link
//  * Implementation details in CommentsModule component
//  */
// export const COMMENTER_NAME_CLASS = 'comment__commenter-name'

type Props = {
  className?: string
  commentedOnText?: string
  createdAt: Date
  authorName: string
  topicTitle?: string
}

function CommentDetails(props: Props) {
  const {
    className,
    commentedOnText,
    createdAt,
    authorName,
    topicTitle,
  } = props

  const timestamp = formatDate(createdAt, "MMMM do, yyyy 'at' h:mm aaaaa'm'")

  return (
    <div className={classNames(style.wrapper, className)}>
      <div className={style.authorName}>
        {/* <div className={classNames(style.name, COMMENTER_NAME_CLASS)}> */}
        {authorName}
      </div>
      <div className={style.annotation}>{timestamp}</div>
      {topicTitle && (
        <div className={classNames(style.annotation, style.topicTitle)}>
          {commentedOnText}: {topicTitle}
        </div>
      )}
    </div>
  )
}

export default CommentDetails
